// Virtual Car
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './publicPath';
import './styles/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import Shell from '@/components/application/Shell';

ReactDOM.render(<Shell />, document.getElementById('root'));
